import { CommunityWins } from '@platform/client';
import { Button, Icon } from '@platform/components';
import { useState } from 'react';
import CarouselBackground from './CarouselBackground.png';
import { CommunityWinsCarouselContent } from './CommunityWinsCarouselContent';

export const CommunityWinsCarousel = () => {
  const communityWins = CommunityWins.useGetCommunityWins({
    page: 0,
    limit: 3,
  });

  const [currentIndex, setCurrentIndex] = useState(0);

  const nextItem = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % (communityWins.data?.length ?? 1));
  };

  const prevItem = () => {
    setCurrentIndex((prevIndex) => {
      if (prevIndex === 0) {
        return (communityWins.data?.length ?? 1) - 1;
      } else {
        return (prevIndex - 1) % (communityWins.data?.length ?? 1);
      }
    });
  };

  return (
    <div
      className='w-full md:h-[408px] min-h-[200px] rounded-lg border border-gray-100 p-4 md:p-6 flex flex-col justify-between relative'
      style={{
        backgroundImage: `url(${CarouselBackground})`,
        backgroundColor: 'rgba(255,255,255,0.4)',
        backgroundBlendMode: 'lighten',
        backgroundSize: 'contain',
      }}
      data-testid='communityWinsCarousel'
    >
      <div className='text-display-xs md:text-display-sm md:font-semibold text-center'>
        🎉 Community Wins 🎉
      </div>

      <div className='md:h-[390px] flex flex-row gap-2 items-center'>
        <Button
          size='lg'
          variant='tertiary-gray'
          onPress={prevItem}
          additionalClassnames='!bg-gray-100 hover:!bg-gray-200 !rounded-full border-none'
        >
          {'<'}
        </Button>
        <div>
          {communityWins.data && communityWins.data[currentIndex] && (
            <CommunityWinsCarouselContent communityWin={communityWins.data[currentIndex]} />
          )}
        </div>
        <Button
          size='lg'
          variant='tertiary-gray'
          onPress={nextItem}
          additionalClassnames='!bg-gray-100 hover:!bg-gray-200 !rounded-full border-none'
        >
          {'>'}
        </Button>
      </div>
      <div className='flex flex-col items-center justify-center gap-2 mt-2'>
        <CarouselPaginationBlock index={currentIndex} />
        <Button
          href='/platform/dashboard/community/community-wins'
          variant='link-color'
          size='md'
          additionalClassnames='text-sm md:text-md'
        >
          See&nbsp;more&nbsp;wins&nbsp;
          <Icon type='arrow-right' size='20' />
        </Button>
      </div>
    </div>
  );
};

type CarouselPaginationBlockProps = {
  index: number;
};

const CarouselPaginationBlock = (props: CarouselPaginationBlockProps) => {
  const { index } = { ...props };
  return (
    <div className='bg-gray-100 rounded-[17px] w-[64px] md:w-[86px] h-[24px] md:h-[34px] p-2 md:p-3 flex flex-row justify-between'>
      <div
        className={`${
          index === 0 ? 'bg-brand-600' : 'bg-gray-300'
        } rounded-md w-2 md:w-2.5 h-2 md:h-2.5`}
      />
      <div
        className={`${
          index === 1 ? 'bg-brand-600' : 'bg-gray-300'
        } rounded-md w-2 md:w-2.5 h-2 md:h-2.5`}
      />
      <div
        className={`${
          index === 2 ? 'bg-brand-600' : 'bg-gray-300'
        } rounded-md w-2 md:w-2.5 h-2 md:h-2.5`}
      />
    </div>
  );
};
